import type { Swiper as SwiperType } from "swiper";

import { ChevronLeftIcon } from "@/components/icons/chevronLeft.icon";
import { ChevronRightIcon } from "@/components/icons/chevronRight.icon";

export const ProductDetailDrawerContentNav = ({
  slideIndex,
  slides,
  swiperRef,
}: ProductDetailDrawerContentNavProps) => {
  const multi = slides.length > 1;

  const progress = (
    <div className="h-1 w-full max-w-[72px] overflow-hidden rounded-full bg-white/30">
      <div
        className="h-full rounded-full bg-white transition-all duration-300"
        style={{
          width: `${((slideIndex + 1) / slides.length) * 100}%`,
        }}
      />
    </div>
  );

  if (!multi) return <div className="mt-4 flex justify-center">{progress}</div>;

  return (
    <div className="mt-4 flex items-center justify-center gap-5">
      <button
        type="button"
        aria-label="Previous slide"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-2 border-white text-white transition-opacity hover:opacity-90"
        onClick={() => swiperRef.current?.slidePrev()}>
        <ChevronLeftIcon className="h-5 w-5" />
      </button>
      {progress}
      <button
        type="button"
        aria-label="Next slide"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-2 border-white text-white transition-opacity hover:opacity-90"
        onClick={() => swiperRef.current?.slideNext()}>
        <ChevronRightIcon className="h-5 w-5" />
      </button>
    </div>
  );
};

type ProductDetailDrawerContentNavProps = {
  slideIndex: number;
  slides: any[];
  swiperRef: React.RefObject<SwiperType>;
};
